
































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

import {
    TransportLoad,
    TransportLoadTransportPart,
} from "../models";

import {
    transportExecuteService,
} from "../services";

import LoadTransportPartEdit from "./LoadTransportPartEdit.vue";

@Component({
    components: {
        LoadTransportPartEdit
    }
})
export default class LoadExecutionDialog extends Vue {
    @Prop() load!: TransportLoad;

    parts: null | TransportLoadTransportPart[] = null;
    comment: null | string = null;

    saving = false;

    get saveDisabled() {
        return this.load.executionInfoMessageSent;
    }

    async mounted() {
        this.parts = this.load.transportParts.map(ltp => Object.assign({}, ltp));
        this.comment = this.load.comment;
    }

    async save() {
        this.saving = true;

        await transportExecuteService.saveLoadExecution(this.load.loadId, {
            items: this.parts!.map(p => ({
                loadTransportPartId: p.loadTransportPartId,
                value: p.value,
            })),
            comment: this.comment!,
        });

        this.$emit("reload");
    }
}
